import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorDevice.module.css';
import Container from 'routes/vendorRe/containers/commons/Container';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import P from 'routes/vendorRe/containers/commons/P';
import {
    commonBgColor,
    commonBodyPadding,
    commonH1Padding,
    commonH1Size,
    contentStart,
} from 'routes/vendorRe/constraint/constraints';
import VendorDeviceList from 'routes/vendorRe/components/VendorDeviceList';
import { requester } from 'App';

const VendorDevice = () => {
    const [isMounted, setMounted] = useState();
    const [stores, setStores] = useState();

    useEffect(() => {
        setMounted(true);
    }, []);
    useEffect(() => {
        if (isMounted) {
            requester.findAllVendorStore(result => {
                
                setStores(result.data);
            });
        }
    }, [isMounted]);

    return (
        <Container backgroundColor={commonBgColor}>
            <div style={{height: "10vh"}}></div>
            <VerticalFlex>
                <FlexChild padding={commonBodyPadding}>
                    <VerticalFlex alignItems={contentStart}>
                        <FlexChild alignItems={contentStart}>
                            <P padding={commonH1Padding} size={commonH1Size}>
                                매장 기기 관리
                            </P>
                            <VerticalFlex>
                                <FlexChild>
                                    <div className={styles.scrollCover}>
                                        <VerticalFlex>
                                            {/* 반복 구간 시작 */}
                                            {stores &&
                                                stores.map((data, index) => {
                                                    return (
                                                        data.machines &&
                                                        data.machines.map(
                                                            (row, index) => {
                                                                return (
                                                                    <VendorDeviceList
                                                                        data={
                                                                            row
                                                                        }
                                                                        storeName={
                                                                            data.storeName
                                                                        }
                                                                    />
                                                                );
                                                            },
                                                        )
                                                    );
                                                })}
                                            {/* 반복 구간 끝 */}
                                        </VerticalFlex>
                                    </div>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default VendorDevice;
